import type { ReactElement } from 'react';
import { MetaStatus } from '@gr/core/content/posts/meta-status';
import type { PostStatusDto } from '@gr/core/content/posts/dto';
import { Badge, type Tone } from '../../../../ui-kit/Badge/Badge';

const TONE: Record<MetaStatus, Tone> = {
  [MetaStatus.Draft]: 'neutral',
  [MetaStatus.Ready]: 'accent',
  [MetaStatus.Published]: 'success',
  [MetaStatus.Retired]: 'warning',
};

/** Статус поста: цвет и имя — от владельца блога, тон — от метастатуса (POST-UC-9). */
export function StatusBadge({ status, fallbackMeta }: { status: PostStatusDto | undefined; fallbackMeta: MetaStatus }): ReactElement {
  return (
    <Badge tone={TONE[status?.meta ?? fallbackMeta]} color={status?.color}>
      {status?.name ?? fallbackMeta}
    </Badge>
  );
}
